import * as React from 'react';
import { useCallback } from 'react';
import cn from 'classnames';
import { useTheme } from '../../theme';
import { getFormattedAmount } from '../utils';
import { useConfig } from '../../context';
import Loader from '../../BaseComponents/Button/components/Loader/Loader';
import { CurrencyMetaMap } from '../constants';
export const Money = ({ money, moneyClassName, amountClassName, currencyClassName, multiplyBy = 1, amountRenderer, currencyRenderer, showCurrency = true, showCurrencyBeforeAmount = false, roundType, isLoading = false, strikethrough = false }) => {
    var _a;
    const { Money: css } = useTheme('Money');
    const { global: { roundMoneyAmount } } = useConfig();
    if (!money) {
        return null;
    }
    // TODO:
    const splitMoneyMin = 999;
    const moneyRoundType = roundType || (roundMoneyAmount && 'round') || null;
    const formattedAmount = React.useMemo(() => getFormattedAmount(money, multiplyBy, moneyRoundType, splitMoneyMin), [
        moneyRoundType,
        money,
        multiplyBy,
        splitMoneyMin
    ]);
    const { symbol: currencySymbol, position } = (_a = CurrencyMetaMap[money.currency]) !== null && _a !== void 0 ? _a : {};
    const hasCurrency = money && showCurrency;
    const showCurrencyBefore = position === 'before' || showCurrencyBeforeAmount;
    const renderCurrency = useCallback(() => {
        if (currencyRenderer) {
            return currencyRenderer(currencySymbol);
        }
        return (React.createElement("span", { "data-currency": money.currency, className: cn(currencyClassName, {
                [css.currency_before]: showCurrencyBefore,
                [css.currency_after]: !showCurrencyBefore
            }) }, currencySymbol));
    }, [currencySymbol, currencyRenderer, showCurrencyBefore]);
    return (React.createElement("span", { className: cn(css.money, { [css.money_loading]: isLoading, [css.money_strikethrough]: strikethrough }, moneyClassName) },
        hasCurrency && showCurrencyBefore && renderCurrency(),
        amountRenderer ? (amountRenderer(money.amount, money.currency, isLoading)) : isLoading ? (React.createElement(Loader, null)) : (React.createElement("span", { className: cn(css.amount, amountClassName) }, formattedAmount
            ? formattedAmount.split(' ').map((part, i) => React.createElement("span", { key: i }, part))
            : (money === null || money === void 0 ? void 0 : money.currency)
                ? '0'
                : null)),
        hasCurrency && !showCurrencyBefore && renderCurrency()));
};
export default Money;
